import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { SIDEBAR_ACTIONS } from "../../../../constants/actionsConstants";

/**
 * useLocationMessageUI - UI Layer hook para LocationMessageMC
 * Encapsula el estado visual y handlers para la gestión de dirección.
 * Cumple con el estándar de separación de Mercately.
 *
 * @returns {Object} Estado visual y handlers
 */
export default function useLocationMessageUI({
  latitude,
  longitude,
  customerWebId
}) {
  const dispatch = useDispatch();
  const openCreateAddress = useCallback(() => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'CustomerAddressSidebar',
        props: {
          loadLocation: true,
          customer: { web_id: customerWebId },
          selectedAddress: { latitude, longitude },
          fakeAddress: false,
          hideNotification: false,
        },
      },
    });
  }, [dispatch, customerWebId, latitude, longitude]);

  return {
    openCreateAddress
  };
}
